import { render, staticRenderFns } from "./TheRule.vue?vue&type=template&id=0d8ba100"
import script from "./TheRule.vue?vue&type=script&lang=js"
export * from "./TheRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports